import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { uploadFile, deleteFile } from "modules/Onboarding/actions";
import { Radio, Spin } from "antd";
import Button from "components/Button";
import PDFBadge from "components/icons/PDFBadge";
import DOCBadge from "components/icons/DOCBadge";
import PILBadge from "components/icons/PILBadge";
import DownloadIcon from "components/icons/DownArrowIcon";
import DeleteIcon from "components/icons/Delete";
import SuccessMessage from "utils/SuccessMessage"
import ErrorMessage from "utils/ErrorMessage"
import moment from "moment";
import ResumeDownload from "modules/Resume/Components/ResumeDownload";
import {
  StyledDrawer,
  FooterFlex,
  DrawerListWrapper, // we created this earlier for spacing
} from "modules/Resume/DrawerComponents/DrawerStyle";

import {
  ResumeCard,
  ResumeLeft,
  ResumeFileName,
  ResumeDate,
  ResumeActions,
  ResumeLimitNote, 
  UploadButtonWrapper
} from "modules/Resume/Style/ResumeStyle";
const MAX_FILES = 6;
const MAX_SIZE_MB = 5;

const UploadResumeDrawer = ({
  drawerStatus,
  setDrawerStatus,
  resumeFiles = [],
  defaultId = "PIL",
  onSave,
  getStudentResumeData,
  studentId,
  studentUpdateAt,
  studentDetails,
  getPendingData,        
  pendingData,
  isResumeFrozen
}) => {
  const dispatch = useDispatch();
  const [localFiles, setLocalFiles] = useState([]);
  const [selectedId, setSelectedId] = useState(defaultId || "PIL");
  const [error, setError] = useState("");
  const [loadingResumes, setLoadingResumes] = useState(false);
  const [submitLoading, setSubmitLoading] = useState(false);  
  console.log(localFiles,'localFiles')
  // Reset local state whenever drawer opens
  useEffect(() => {
    if (drawerStatus) {
      setLocalFiles([]);
      setSelectedId(defaultId || "PIL");
      setError("");
    }
  }, [drawerStatus, defaultId]);

  useEffect(() =>{
    fetchResumeData()
  },[])
  const mapPendingResumesToUi = (pendingResumes = []) =>
  pendingResumes.map(r => ({
    id: r._itemId,
    name: r.resumeName,
    type: r.resumeType,
    url: r.fileUrl?.url || "",
    uploadedOn: new Date().toLocaleDateString("en-GB"),
    isDefault: false,
    isPending: r._status === "PENDING",
    fileFormat:
      r.fileFormat ||
      r.resumeName?.split(".").pop()?.toLowerCase() ||
      "pdf",
    _raw: r,
  }));
const mapApiResumesToUi = (backendResumes = []) =>
  backendResumes.map((r) => ({
    id: r.id,
    name: r.resumeName,
    type:
      r.resumeType === "SYSTEM"
        ? "SYSTEM"
        : "UPLOADED",
    url: r.fileUrl?.url || "",
    uploadedOn: new Date(r.createdAt).toLocaleDateString("en-GB"),
    isDefault: r.isDefault,
    fileFormat: r.fileFormat?.toLowerCase() || null,
    _raw: r,
  }));

  const fetchResumeData = async () => {
    //add Loader
    setLoadingResumes(true);  // 🔵 START LOADER
  try {
const result = await getStudentResumeData(studentId);
await getPendingData(); // 🔴 FETCH pending

const approvedUi = mapApiResumesToUi(
  result?.resumes || result?.data?.resumes || []
);

const pendingUi = mapPendingResumesToUi(
  pendingData?.resumes || []
);

setLocalFiles([...approvedUi, ...pendingUi]);
  } catch (error) {
    console.error("❌ Failed to load resumes:", error);
  } finally {
    setLoadingResumes(false);  // 🔴 STOP LOADER
  }
};  const handleClose = () => {
    setDrawerStatus(false);
  };

//   const handleSave = async () => {
//     try {
//       // Filter out any temporary blob URLs and only keep the server URLs
//       const filesToSave = localFiles.map(file => ({
//         ...file,
//         // If it's a blob URL, we need to handle it differently as it's temporary
//         // You might want to upload the file here if it hasn't been uploaded yet
//         // For now, we'll just skip files with blob URLs that aren't yet uploaded
//         // This is a simplified approach - you might need to adjust based on your requirements
//       }));
//       console.log(filesToSave,'filesToSave')
//       let payload = {
//   "resumes": [
//     {
//       "id": null,
//       "resumeName": "Resume 2025",
//       "resumeType": "UPLOADED",
//       "fileUrl": { "url": "https://example.com/resume.pdf" },
//       "isDefault": true,
//       "fileSize": 1024
//     },
//     {
//       "id": "bb8f86c5-e1c1-4bf2-853e-4e42463a3cbf",
//       "resumeName": "System Generated",
//       "resumeType": "SYSTEM",
//       "fileUrl": { "type": "SYSTEM_GENERATED", "url": null },
//       "isDefault": false
//     }
//   ]
// }
// await upsertStudentResume(payload)
//       onSave(selectedId, filesToSave);
//       setResumeFiles(filesToSave);
//       setDrawerStatus(false);
//     } catch (error) {
//       console.error('Save error:', error);
//       ErrorMessage('Failed to save changes');
//     }
//   };
const handleSave = () => {
  setSubmitLoading(true);
  onSave(localFiles, selectedId);
  setDrawerStatus(false);
  setSubmitLoading(false);
};
  const handleUpload = async (event) => {
    setLoadingResumes(true);
    const file = event.target.files[0];
    if (!file) return;

    const ext = file.name.split('.').pop().toLowerCase();
    const validExts = ['pdf'];
    
    if (!validExts.includes(ext)) {
      setError('Only PDF files are allowed');
      event.target.value = "";
      return;
    }

    if (file.size > MAX_SIZE_MB * 1024 * 1024) {
      setError(`File size should not exceed ${MAX_SIZE_MB}MB`);
      event.target.value = "";
      return;
    }

    if (localFiles.length >= MAX_FILES) {
      setError(`Maximum ${MAX_FILES-1} files allowed`);
      event.target.value = "";
      return;
    }

    setError("");

    try {
      // Upload the file to the server
      const uploadedFileUrl = await dispatch(uploadFile(file, `resume_${Date.now()}.${ext}`));
      
      if (!uploadedFileUrl) {
        throw new Error('File upload failed');
      }

      const newFile = {
        id: Date.now(),
        file,
        name: file.name,
        type: ext.toUpperCase(),
        fileFormat: ext,
        uploadedOn: new Date().toLocaleDateString("en-GB"),
        url: uploadedFileUrl, // Use the URL from the server
        _raw: {
        id: null,
        resumeName: file.name,
        resumeType: "UPLOADED",
        fileUrl: { url: uploadedFileUrl },
        isDefault: false,
 }
};

      setLocalFiles((prev) => [...prev, newFile]);
      setSubmitLoading(false);
      // setSelectedId(newFile.id);
   //   SuccessMessage('Resume uploaded successfully!');
    } catch (error) {
      console.error('Upload error:', error);
      ErrorMessage('Failed to upload resume');
    } finally {
      // Reset the file input to allow re-uploading the same file
      event.target.value = "";
      setLoadingResumes(false);
    }
  };

  const handleDelete = async (id) => {
    setLoadingResumes(true);
    const fileToDelete = localFiles.find(f => f.id === id);
    if (!fileToDelete) return;

    try {
      // If it's a server-uploaded file (has a URL), delete it from the server
      if (fileToDelete.url && !fileToDelete.url.startsWith('blob:')) {
        const success = await dispatch(deleteFile(fileToDelete.url));
        if (!success) {
          throw new Error('Failed to delete file from server');
        }
      }

      // Update local state
      setLocalFiles((prev) => {
        const updated = prev.filter((f) => f.id !== id);

        // If deleted file was the selected default
        if (selectedId === id) {
  let newDefault =
    // 1️⃣ Use backend default if it exists
    updated.find(f => f.isDefault)?.id ||
    // 2️⃣ Else first resume
    updated[0]?.id ||
    // 3️⃣ Else fallback to PIL
    "PIL";

  setSelectedId(newDefault);
}

        return updated;
      });

      SuccessMessage('Resume deleted successfully!');
    } catch (error) {
      console.error('Delete error:', error);
      ErrorMessage('Failed to delete resume');
    }finally {
      setLoadingResumes(false);
    }
  };
      const downloadURI = async (file) => {
      // Create a blob from the URL to force download
      try {
        const response = await fetch(file.url)
        if (!response.ok) {
          throw new Error('Failed to download file')
        }
        const blob = await response.blob()
        const url = URL.createObjectURL(blob)
        const a = document.createElement('a')
        a.href = url
        a.download = file.name
        document.body.appendChild(a)
        a.click()
        URL.revokeObjectURL(url)
        document.body.removeChild(a)
      } catch (error) {
        console.error('Error downloading file:', error)
      }
    }

const renderUserFiles = () =>
  localFiles.map((file) => {
    const isSelected = selectedId === file.id;
    const isPdf = file.fileFormat === "pdf" ;
    const isDefault = file.isDefault;
    const isTemporary = file?._raw?.id === null;
    if (file.type !== "SYSTEM") {
      return (
        <ResumeCard
          key={file.id}
          style={{
            cursor: file.isPending || isTemporary ? "not-allowed" : "pointer",
            background: isDefault ? "#DAECFF" : "#FFFFFF",
            border: `1px solid ${isSelected && !isDefault ? "#3249D7" : "#E6E7EA"
    }`,
          }}
          onClick={() => {
  if (!file.isPending && !isTemporary) {
    setSelectedId(file.id);
  }
}}
        >
          <ResumeLeft>
            {isPdf ? <PDFBadge /> : <DOCBadge />}
            <div>
              <ResumeFileName>{file.name}</ResumeFileName>
              <ResumeDate>Uploaded on {file.uploadedOn}</ResumeDate>
            </div>
          </ResumeLeft>

          <ResumeActions>
            {file.isDefault && (
              <div
                style={{
                  width: 67,
                  height: 26,
                  borderRadius: 5,
                  background: "#F2F7FF",
                  border: "1px solid #DAE6FF",
                  color: "#3A66FF",
                  fontSize: 12,
                  fontWeight: 500,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  marginRight: 10,
                }}
              >
                Default
              </div>
            )}
            {file.isPending && (
  <div
    style={{
      marginTop: 4,
      padding: "2px 8px",
      borderRadius: 6,
      background: "#FFF7E6",
      color: "#FA8C16",
      fontSize: 12,
      fontWeight: 600,
      display: "inline-block",
    }}
  >
    Pending Approval
  </div>
)}

            <span
              onClick={(e) => {
                e.stopPropagation();
                downloadURI(file);
              }}
            >
              <DownloadIcon />
            </span>
            {(!isResumeFrozen || file.isPending) && (
            <span
              onClick={(e) => {
                e.stopPropagation();
                handleDelete(file.id);
              }}
            >
              <DeleteIcon />
            </span>
            )}
            <Radio
  checked={isSelected}
  disabled={file.isPending || isTemporary}
  onChange={() => {
    if (!file.isPending && !isTemporary) {
      setSelectedId(file.id);
    }
  }}
/>
          </ResumeActions>
        </ResumeCard>
      );
    } else {
      return (
        <ResumeCard
          key={file.id}
          style={{
            cursor: file.isPending || isTemporary ? "not-allowed" : "pointer",
            background: isDefault ? "#DAECFF" : "#FFFFFF",
            border: `1px solid ${isSelected && !isDefault ? "#3249D7" : "#E6E7EA"}`,
          }}
          onClick={() => {
  if (!file.isPending && !isTemporary) {
    setSelectedId(file.id);
  }
}}
        >
          <ResumeLeft>
            <PILBadge />
            <div>
              <ResumeFileName>PIL Resume</ResumeFileName>
              <ResumeDate>Updated on {moment(file._raw.updateAt).format("DD/MM/YYYY")}</ResumeDate>
            </div>
          </ResumeLeft>

          <ResumeActions>
            {file.isDefault && (
              <div
                style={{
                  width: 67,
                  height: 26,
                  borderRadius: 5,
                  background: "#F2F7FF",
                  border: "1px solid #DAE6FF",
                  color: "#3A66FF",
                  fontSize: 12,
                  fontWeight: 500,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  marginRight: 10,
                }}
              >
                Default
              </div>
            )}
            <div
              style={{
                padding: "4px 10px",
                borderRadius: "999px",
                background: "#EEF0FF",
                fontSize: 11,
                fontWeight: 600,
                color: "#3249D7",
              }}
            >
              System Generated
            </div>
            <ResumeActions>
              {studentDetails ? (
                <ResumeDownload studentData={studentDetails}>
                  {({ url, fileName }) => (
                    <a
                      href={url || undefined}
                      download={fileName}
                      onClick={(e) => {
                        e.stopPropagation();
                      }}
                      style={{ display: 'inline-flex', alignItems: 'center' }}
                    >
                      <DownloadIcon />
                    </a>
                  )}
                </ResumeDownload>
              ) : (
                <span onClick={null}>
                  <DownloadIcon />
                </span>
              )}
            </ResumeActions>
            <Radio
  checked={isSelected}
  disabled={file.isPending || isTemporary}
  onChange={() => {
    if (!file.isPending && !isTemporary) {
      setSelectedId(file.id);
    }
  }}
/>
          </ResumeActions>
        </ResumeCard>
      );
    }
  });

  const renderPil = () => {
    const isSelected = selectedId === "PIL";

    return (
      <ResumeCard
        style={{
          cursor: file.isPending || isTemporary ? "not-allowed" : "pointer",
          background: isSelected ? "#DAECFF" : "#FFFFFF",
        }}
        onClick={() => {
  if (!file.isPending && !isTemporary) {
    setSelectedId(file.id);
  }
}}
      >
        <ResumeLeft>
          <PILBadge />
          <div>
            <ResumeFileName>PIL Resume</ResumeFileName>
            <ResumeDate>Updated on {moment(file._raw.updateAt).format("DD/MM/YYYY")}</ResumeDate>
          </div>
        </ResumeLeft>

        <ResumeActions>
          <div
            style={{
              padding: "4px 10px",
              borderRadius: "999px",
              background: "#EEF0FF",
              fontSize: 11,
              fontWeight: 600,
              color: "#3249D7",
            }}
          >
            System Generated
          </div>
          <Radio
  checked={isSelected}
  disabled={file.isPending || isTemporary}
  onChange={() => {
    if (!file.isPending && !isTemporary) {
      setSelectedId(file.id);
    }
  }}
/>
        </ResumeActions>
      </ResumeCard>
    );
  };

  const content = () => (
    <>
      <DrawerListWrapper>
        <DrawerListWrapper>
  {loadingResumes ? (
    <div style={{ textAlign: "center", padding: "40px" }}>
      <Spin size="large" />
    </div>
  ) : (
    renderUserFiles()
  )}
</DrawerListWrapper>
        
      </DrawerListWrapper>

      {/* Hidden input inside drawer */}
      <input
        id="upload-resume-input-drawer"
        type="file"
        accept=".pdf"
        style={{ display: "none" }}
        onChange={handleUpload}
      />

      <div style={{ marginTop: 16 }}>
        {localFiles.length < MAX_FILES ? (
  <UploadButtonWrapper>
    <Button.Secondary
      text="Upload New Resume"
      onClick={() =>
        document
          .getElementById("upload-resume-input-drawer")
          .click()
      }
    />
  </UploadButtonWrapper>
) : (
  <ResumeLimitNote>
    You’ve reached the limit of 5 resumes. <br />
    To upload a new file, please remove an existing resume.
  </ResumeLimitNote>
)}
      </div>

      {error && (
        <div style={{ color: "red", marginTop: 8, fontSize: 13 }}>
          {error}
        </div>
      )}
    </>
  );

  const footer = () => (
    <FooterFlex right>
      <Button.Secondary text="Cancel" onClick={handleClose} />
      <Button.Primary
        text="Save"
        disable={submitLoading}
        disabled={!selectedId && localFiles.length === 0 && submitLoading}
        onClick={handleSave}
      />
    </FooterFlex>
  );

  return (
    <StyledDrawer
      width="720px"
      title="Upload New Resume"
      placement="right"
      closable
      onClose={handleClose}
      visible={drawerStatus}
      content={content()}
      footer={footer()}
    />
  );
};

export default UploadResumeDrawer;
